import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
    },
    linkSignup: {
        color: '#2f9ab7',
        textDecoration: 'none'
    },
    content: {
        padding: '30px',
        position: 'absolute',
        left: '50%',
        top: '50%',
        textAlign: 'center',
        transform: 'translate(-50%, -50%)',
    },
    button: {
        padding: '12px',
        width: '100%',
        background: '#fe7d00',
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        fontSize: '18px;',
        marginTop: '10px',
        cursor: 'pointer',
    },
    disabledButton: {
        padding: '12px',
        width: '100%',
        border: 'none',
        borderRadius: '10px',
        fontSize: '18px;',
        marginTop: '10px',
        backgroundColor: '#cbcbcb',
        color: '#8c8c8c',
    },
    card: {
        display: 'block',
        flexGrow: 1,
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        flex: '1',
        margin: '0px',
        width: '100%',
        textAlign: 'left',
    },
    formControl: {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginLeft: '12px',
        marginRight: '16px',
        '& .MuiIconButton-root': {
            padding: '0',
            paddingRight: '6px',
        },
    },
    bgHeader: {
        background: '#F7F7F7',
    },
    innerWrapper: {
        width: `calc(100% - 40px)`,
    },
    loader: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
    },
    textSecondary: {
        margin: '16px 0',
    },
    accept: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: '10px 0',
    },
    flagButton: {
        minWidth: 34,
        width: 34,
        padding: "4px !important",
        height: 25,
        margin: 0,
        borderRadius: 0,
        '&:focus': {
            outline: 'none',
            boxShadow: 'none',
        },
        '&:focus-visible': {
            outline: 'none',
            boxShadow: 'none',
        },
    },
    flagItem: {
        height: '20px',
        padding: 0,
        minWidth: '30px',
        maxWidth: 30,
        marginLeft: '5px',
        marginRight: '15px',
        paddingTop: '0px',
        position: 'relative',
    },
    styleCircular: {
        marginRight: '10px', width: '15px !important', height: '15px !important', color: '#FFFFFF'
    },
    txtLabel: {
        fontFamily: 'Gellix',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '16px',
        lineHeight: '24px',
        color: '#000000',
        flex: 'none',
        order: 0,
        flexGrow: 1,
    },
    txtLabel_ar: {
        fontFamily: 'TheSansArab',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '16px',
        lineHeight: '24px',
        color: '#000000',
        flex: 'none',
        order: 0,
        flexGrow: 1,
    },
    stylePhone: {
        background: 'transparent',
        borderRadius: 0,
        padding: 0,
        fontSize: 16,
        width: 'auto',
        textAlign: 'left',
        margin: 0,
        fontFamily: 'Gellix',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '20px',
        whiteSpace: 'nowrap',
        color: '#263856',
        flex: 'none',
        order: 0,
        flexGrow: 0,
        cursor: 'pointer'
    }
}));
